import { render, staticRenderFns } from "./vOrder.vue?vue&type=template&id=27c1cb3e&"
import script from "./vOrder.vue?vue&type=script&lang=js&"
export * from "./vOrder.vue?vue&type=script&lang=js&"
import style0 from "./vOrder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports